import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/payments/Amex.png")